import { Fragment, useState } from "react";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import Button from "../Button/Button";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import { FiEdit } from "react-icons/fi";
import { EditActionModal } from "../Dialog/EditActionModal";
import { Link } from "react-router-dom";
import { ChangeActivityDateModal } from "../Dialog/ChangeActivityDateModal";
import { useRecoilState } from "recoil";
import { crmActionCheckListAtom } from "../../shared/crm-action-checklist";
import { DeleteActivityModal } from "../Dialog/DeleteActivitiyModal";
import { successMessage } from "../../utils/message";
const initmodalvalue = {
  editaction: false,
  changeactivitydate: false,
  deleteactivity: false,
};
export const TodayActions = ({ data, isLoading, users }) => {
  const [show, setShow] = useState(initmodalvalue);
  const [checked, setChecked] = useRecoilState(crmActionCheckListAtom);
  const [Search, setSearch] = useState("");
  const [editActionData, setEditActionData] = useState();

  const headerTitle = [
    "ردیف",
    "انتخاب",
    "نام و نام خانوادگی ",
    "شماره تماس",
    "وضعیت کاربر",
    "عنوان فعالیت",
    "مسئول",
    "دسته بندی",
    "تاریخ فعالیت",
    "عملیات",
  ];

  const length = data?.filter((item) => {
    if (
      item.SubjectActivityCrm == "مراجعه به انبار" ||
      item.SubjectActivityCrm === "شارژ محصول" ||
      item.SubjectActivityCrm === "ویزیت حضوری" ||
      item.SubjectActivityCrm === "پیگیری دوره ای تماس" ||
      item.SubjectActivityCrm === "مراجعه به انبار" ||
      item.SubjectActivityCrm === "مراجعه حضوری" ||
      item.SubjectActivityCrm === "صدور پیش فاکتور توسط Crm"
    ) {
    } else {
      return item;
    }
  });

  const items = data
    ?.filter((item) => {
      if (Search === "") {
        return item;
      } else if (
        (item?.FirstName + " " + item?.LastName).indexOf(Search) >= 0
      ) {
        return item;
      } else if (item?.SubjectActivityCrm?.indexOf(Search) >= 0) {
        return item;
      } else if (
        item?.NameCategory !== null &&
        item?.NameCategory?.indexOf(Search) >= 0
      ) {
        return item;
      }
    })
    .map((item, index) => {
      return item.SubjectActivityCrm === "مراجعه به انبار" ||
        item.SubjectActivityCrm === "شارژ محصول" ||
        item.SubjectActivityCrm === "ویزیت حضوری" ||
        item.SubjectActivityCrm === "پیگیری دوره ای تماس" ||
        item.SubjectActivityCrm === "مراجعه به انبار" ||
        item.SubjectActivityCrm === "مراجعه حضوری" ||
        item.SubjectActivityCrm === "صدور پیش فاکتور توسط Crm" ? null : (
        <tr key={item.IdActivityCrm}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <input
                type="checkbox"
                value={item.IdActivityCrm}
                onChange={() => {
                  setChecked((prevState) => {
                    if (prevState.includes(item.IdActivityCrm)) {
                      return prevState.filter(
                        (st) => st !== item.IdActivityCrm
                      );
                    } else {
                      return [...prevState, item.IdActivityCrm];
                    }
                  });
                }}
              />
            </span>
          </td>
          <td>
            <Link
              to={`/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`}
            >
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {users?.map((user) =>
                  user.IdActivityCrm === item.IdActivityCrm
                    ? (user.FirstName ? user.FirstName : "") +
                      " " +
                      (user.LastName ? user.LastName : "")
                    : null
                )}
              </span>
            </Link>
          </td>
          <td>
            <Link
              to={`/dashboard/crm/customer-file/${item.IdS0alesOpportunities}`}
            >
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {users?.map((user) =>
                  user.IdActivityCrm === item.IdActivityCrm
                    ? "0" + user.Phone
                    : null
                )}
              </span>
            </Link>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.KindCustomer}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.SubjectActivityCrm}
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(item.FirstName ? item.FirstName : "") +
                " " +
                (item.LastName ? item.LastName : "")}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {users?.map((user) =>
                item.IdActivityCrm === user.IdActivityCrm
                  ? user.NameCategory
                  : null
              )}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(item.DateReferenceActivityCrm)}
            </span>
          </td>
          <td>
            <div className="d-flex">
              <Button
                bgColor="#0d6efd"
                small="fit-content"
                onclick={() => {
                  setShow({ ...show, editaction: true });
                  setEditActionData(item);
                }}
              >
                <FiEdit color="#fff" />
              </Button>
            </div>
          </td>
        </tr>
      );
    });

  return (
    <Fragment>
      {isLoading ? (
        <Loading />
      ) : (
        <Table
          headerTitle={headerTitle}
          title={`فعالیت های امروز ${length?.length}`}
          items={items}
          setSearch={setSearch}
          content={
            <div className="d-flex">
              <Button
                small="fit-content"
                bgColor="#009ef7"
                color="#fff"
                className="mx-2 mb-2"
                size="12px"
                onclick={() => {
                  setShow({ ...show, changeactivitydate: true });
                }}
              >
                تغییر تاریخ
              </Button>
              <Button
                small="fit-content"
                bgColor="#f1416c"
                color="#fff"
                className="mb-2"
                size="12px"
                onclick={() => {
                  setShow({ ...show, deleteactivity: true });
                }}
              >
                حذف
              </Button>
            </div>
          }
        />
      )}
      <EditActionModal
        show={show.editaction}
        handleClose={() => setShow({ ...show, editaction: false })}
        editActionData={editActionData}
      />
      <ChangeActivityDateModal
        show={show.changeactivitydate}
        handleClose={() => setShow({ ...show, changeactivitydate: false })}
        dates={checked.toString()}
      />
      <DeleteActivityModal
        show={show.deleteactivity}
        handleClose={() => setShow({ ...show, deleteactivity: false })}
        dates={checked.toString()}
      />
    </Fragment>
  );
};
